export default "<span>\r\n    {{message}}\r\n</span>"